module.exports = __webpack_public_path__ + "img/payment-type-card-fallback.77bdb302.svg";